import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import PropTypes from 'prop-types';

const HexColorPicker = (props) => {
  const { onHandleChange, colorSelected } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState('#491F86');

  const handleChange = (colorValue) => {
    const { hex } = colorValue;
    setColor(hex);
  };

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    handleClick();
    onHandleChange(color);
  };

  useEffect(() => {
    if (colorSelected) {
      setColor(colorSelected);
    }
  }, [colorSelected]);

  return (
    <div className="hex-color-picker">
      <button
        type="button"
        style={{ background: color }}
        className="hex-color-picker-button"
        onClick={handleClick}
      />
      {displayColorPicker ? (
        <div className="picker-wrapper">
          <button
            type="button"
            className="button-close"
            onClick={handleClose}
          />
          <SketchPicker color={color} onChange={handleChange} disableAlpha />
        </div>
      ) : null}
    </div>
  );
};

HexColorPicker.propTypes = {
  onHandleChange: PropTypes.func.isRequired,
  colorSelected: PropTypes.string,
};

HexColorPicker.defaultProps = {
  colorSelected: null,
};

export default HexColorPicker;
